import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import { mobileCSS } from '@measures/responsive'
import translate from '@i18n'
import QRCode from '@components/BlickPlusOnboardingModal/AppPage/QRCode'
import StoreIcons from '@components/BlickPlusOnboardingModal/AppPage/StoreIcons'
import Text from '@components/BlickPlusOnboardingModal/Text'
import Title from '@components/BlickPlusOnboardingModal/Title'

const StyledWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing40, spacing24 },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing40};
    margin-bottom: ${spacing24};
    ${mobileCSS(css`
      display: none;
    `)}
  `}
`

const StyledHeadline = styled.div`
  ${({
    theme: {
      spacing: { spacing16 },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing16};
  `}
`

const StyledSubTitle = styled.div`
  ${({
    theme: {
      typography: {
        bodycopy: {
          medium2: { bundledCSS: medium2BodycopyCSS },
        },
      },
    },
  }) => css`
    ${medium2BodycopyCSS};
    line-height: 1.2;
  `}
`

const StyledText = styled(Text)`
  font-weight: 700;
`

const StyledQRCodeWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing24 },
    },
  }) => css`
    display: flex;
    flex-direction: row;
    gap: ${spacing24};
    align-items: center;
    justify-content: center;
  `}
`

const AppPageDesktop: FunctionComponent = () => (
  <StyledWrapper>
    <StyledHeadline>
      <Title>{translate('blickPlusOnboardingModal.appPage.title')}</Title>
      <StyledSubTitle>
        {translate('blickPlusOnboardingModal.appPage.text')}
      </StyledSubTitle>
    </StyledHeadline>
    <StyledQRCodeWrapper>
      <QRCode />
      <StoreIcons />
    </StyledQRCodeWrapper>
    <Text>
      <StyledText>
        {translate('blickPlusOnboardingModal.appPage.sportQuestion')}
      </StyledText>
      {translate('blickPlusOnboardingModal.appPage.sportText')}
    </Text>
  </StyledWrapper>
)

export default AppPageDesktop
